import * as React from 'react';
import NearbySlotsContext, {
    NearbySlots,
} from '../../NearbySlotsProvider/context';

export default function useNearbySlots(locationId: string): NearbySlots | null {
    const { locations } = React.useContext(NearbySlotsContext);

    return React.useMemo(() => {
        return locations[locationId] ?? null;
    }, [locationId, locations]);
}
